import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user) {
      api
        .get("/wishlist")
        .then((r) => setIds(r.data.product_ids || []))
        .catch(() => setIds([]));
    } else {
      setIds([]);
    }
  }, [user]);

  const toggle = async (productId) => {
    if (!user) {
      toast("Sign in to save to your Chambers", {
        description: "Your saved pieces live in your account.",
      });
      return null;
    }
    try {
      const { data } = await api.post("/wishlist/toggle", { product_id: productId });
      setIds((prev) =>
        data.saved ? [productId, ...prev.filter((i) => i !== productId)] : prev.filter((i) => i !== productId),
      );
      return data.saved;
    } catch {
      toast.error("Could not update your Chambers");
      return null;
    }
  };

  const has = (productId) => ids.includes(productId);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
